import { ThemeColorName } from '@examdojo/styles';
import { TableInsertModel, ViewRowModel } from '@examdojo/supabase';

export const CLASS_SLUG_PARAM = 'classSlug';
export const JOIN_CLASS_CODE_PARAM = 'code';
export const JOIN_CLASS_PARAM = 'joinClass';

export interface BaseClassModel {
  id: string;
  slug: string;
  name: string;
  color: ThemeColorName | null;
  emoji: string | null;
  school_name: string | null;
  course_name: string | null;
  syllabus_name: string | null;
  student_count: number | null;
  archived_at?: string | null;
  teacherName?: string | null;
}

export type ClassHttpModel = ViewRowModel<'teacher_classes_list', 'classroom'>;

export type ClassStoreModel = ClassHttpModel & BaseClassModel;

export type ClassUIModel = ClassStoreModel;

export type ClassColor = ThemeColorName;

export type ClassFormData = Omit<TableInsertModel<'classes', 'classroom'>, 'teacher_id'>;
